<template>
  <el-dialog
    title="退货数量"
    :visible.sync="visible"
    width="80%"
    custom-class="detail_dialog" :top="'5vh'" :fullscreen="isExpand"
    :show-close="false" :before-close="handleClose">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>退货数量</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <table-with-pagination
      ref="xTable"
      :showRightToolbar="false"
      :columnList="refundGoodsColumns"
      :tableData="refundGoodsList"
      :height="500"
    />
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">关闭</el-button>
      <slot name="button"></slot>
    </span>
  </el-dialog>
</template>
<script>
import TableWithPagination, {
  TablePaginationMixin,
} from '@/components/common/TableWithPagination';
import { returnedMaterialList } from '@/api/service';
import * as Moment from 'dayjs';
const formateDate = (date, format) => {
  if (!date) {
    return '--';
  } else {
    return Moment(date).format(format);
  }
};
export default {
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
  },
  data () {
    return {
      id: '',
      isExpand: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      visible: false,
      refundGoodsList: [],
      refundGoodsColumns: [
        {
          prop: 'warehouseName',
          label: '入库仓库',
          tooltip: true,
        },
        {
          prop: 'systemSerialNumber',
          label: '系统序列号',
          tooltip: true,
        },
        {
          prop: 'goodsCode',
          label: '商品编码',
          tooltip: true,
        },
        {
          prop: 'goodsName',
          label: '商品名称',
          tooltip: true,
        },
        {
          prop: 'specification',
          label: '规格',
          tooltip: true,
        },
        {
          prop: 'model',
          label: '型号',
          tooltip: true,
        },
        {
          prop: 'brandName',
          label: '品牌名称',
          tooltip: true,
        },
        {
          prop: 'producer',
          label: '生产商',
        },
        {
          prop: 'factoryCode',
          label: '厂家编码',
        },
        {
          prop: 'returnAbleNum',
          label: '可退货数量',
          render: (h, { row }) => {
            // ERP 按序列号逐条返回，每条可退 1；小紫中台按商品行返回，取售后数量
            return h('span', row.middleQuantity !== undefined ? row.middleQuantity : 1);
          },
        },
        {
          prop: 'productionDate',
          label: '生产日期',
          tooltip: true,
          format: val => formateDate(val, 'YYYY-MM-DD'),
        },
        {
          prop: 'expiryDate',
          label: '失效日期',
          tooltip: true,
          format: val => formateDate(val, 'YYYY-MM-DD'),
        },
        {
          prop: 'warehousingBatch',
          label: '入库批次',
          tooltip: true,
        },
        {
          prop: 'isMedichair',
          label: '是否医疗件',
          tooltip: true,
          format: val => (val === 1 ? '是' : val === 2 ? '否' : ''),
        },
        {
          prop: 'batchNumber',
          label: '生产批次号',
          tooltip: true,
        },
        {
          prop: 'serialNumber',
          label: '生产序列号',
          tooltip: true,
        },
        {
          prop: 'regNo',
          label: '注册证号',
          tooltip: true,
        },
      ],
    };
  },
  methods: {
    handleClose () {
      this.visible = false;
    },
    getRefundReturnGoods (row) {
      this.visible = true;
      returnedMaterialList({materialId: row.materialId, id: this.id, afterItemId: row.id}).then(({ body }) => {
        this.refundGoodsList = body || [];
      });
    },
    // 小紫中台来源：数据不在进销存，直接展示平台本地的售后商品行
    showMiddleRefundGoods (goods) {
      this.visible = true;
      this.refundGoodsList = [{
        goodsCode: goods.outSkuCode,
        goodsName: goods.goodsName,
        specification: goods.specification,
        model: goods.model,
        brandName: goods.brandName,
        producer: goods.manufacturer,
        factoryCode: goods.factoryCode,
        middleQuantity: goods.quantity,
        isMedichair: goods.medicalFlag === true ? 1 : goods.medicalFlag === false ? 2 : null,
        batchNumber: goods.batchNo,
        serialNumber: goods.serialNo,
        regNo: goods.certificateNumber,
      }];
    },
  },
};
</script>
<style lang="scss" scoped>
.detail_dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }
}
</style>
